import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger
} from "@/components/ui/accordion";

const FAQS = [
    {
        q: "How are your fees structured?",
        a: "Most estate-planning packages, entity formations, and real-estate closings are handled on a flat-fee basis so you know the cost before we begin. Complex or ongoing matters are quoted with a written engagement letter."
    },
    {
        q: "Do I need a trust, or just a will?",
        a: "It depends on what you own, who you want to receive it, and how much privacy and probate-avoidance matters to you. Many of our clients use a revocable trust paired with a pour-over will. We will walk through the tradeoffs in plain language before you commit to a structure."
    },
    {
        q: "Can you help with real-estate purchases and sales?",
        a: "Yes. We handle title examinations, contracts, deeds, easements, and closings on residential, rural, and commercial property."
    },
    {
        q: "What should I bring to a consultation?",
        a: "For estate matters, bring deeds, prior wills or trusts, and a rough list of assets and beneficiaries. For real estate, bring the contract or title. For business matters, bring any existing operating agreement or contracts. If you aren’t sure, just come. We will sort it out together."
    },
    {
        q: "Do you offer remote consultations?",
        a: "Yes. We meet by phone, video, or in person, whichever fits your schedule and the matter. Many clients prefer a first call by phone and an in-person sit-down for signing."
    },
    {
        q: "How do I get started?",
        a: "Email info@chesterton.law with a sentence or two about your matter. We reply within one business day with next steps or a time to talk."
    }
];

export default function FAQ() {
    return (
        <section
            data-testid="faq-section"
            className="py-24 lg:py-32 bg-white border-y border-acre-line"
        >
            <div className="max-w-[1100px] mx-auto px-6 md:px-10 lg:px-16">
                <div className="max-w-2xl mb-14">
                    <div className="text-[11px] uppercase tracking-[0.28em] text-acre-secondary mb-5">
                        Frequently Asked
                    </div>
                    <h2 className="font-serif-display text-4xl lg:text-5xl tracking-tight leading-[1.05] text-acre-secondary">
                        Questions we hear often.
                    </h2>
                </div>

                <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                    {FAQS.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`item-${i}`}
                            className="border-acre-line"
                            data-testid={`faq-item-${i}`}
                        >
                            <AccordionTrigger className="text-left font-serif-display text-xl lg:text-2xl text-acre-ink hover:text-acre-primary py-6">
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-acre-muted text-base leading-relaxed pb-8">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
}
